import { Popover, PopoverDisclosure, PopoverProvider } from '@ariakit/react';
import { IconSearch } from 'featherico';
import { useRef } from 'react';
import Button from '../../components/Button';
import { NavItemButton } from '../Navigation/Item';
import Result from './Result';
import SearchInput from './SearchInput';
import styles from './style.m.less';

const eventTracking = { category: 'navigation header search bar', action: 'click jump to' };

export default function HeaderSearchBar({ showResults, actions, openSearch, compact }) {
    const inputRef = useRef();

    return (
        <PopoverProvider
            placement={compact ? 'right-end' : 'top-start'}
            open={showResults}
            setOpen={open => (open ? openSearch() : actions.doHideResults())}
        >
            <PopoverDisclosure
                render={
                    compact ? (
                        <NavItemButton
                            icon={<IconSearch />}
                            label="Search"
                            eventTracking={eventTracking}
                            title='Press "j" to open'
                            compact
                        />
                    ) : (
                        <Button
                            kind="PLAIN"
                            aria-label="Jump to Cycle or Employee"
                            eventTracking={eventTracking}
                            title='Press "j" to open'
                        >
                            <IconSearch />
                        </Button>
                    )
                }
            />
            <Popover gutter={5} unmountOnHide className={styles.popover} initialFocus={inputRef}>
                <Result />
                <SearchInput ref={inputRef} />
            </Popover>
        </PopoverProvider>
    );
}
